// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsView from "../../../../../engines/libs/utilsView";
import ModelDialogLayer from "../../../../gameCommon/basic/ModelDialogLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitMainDetail extends BasePopUpLayer {

    @property(cc.Label)
    labelDesc: cc.Label = null;

    @property(cc.ScrollView)
    scrollView: cc.ScrollView = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        this.labelDesc.string = this._carryData.desc;
        utilsView.refreshLabelUI(this.labelDesc);
        this.scrollView.content.height = this.labelDesc.node.height;
    }

    onClickMade() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
        this._carryData.parent.onClickSelect();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        ModelDialogLayer.show('确定退出衙门吗？', null, ()=> {
            this.destroyNode();
            this._carryData.parent.closeLayer();
        });
    }

    // update (dt) {}
}
